<div class="row mb-3">
  <div class="col-12 text-center"><h3 translate>QUICKORDER</h3></div>
</div>
<div class="row">
  <div class="col-12 col-md-8">
    <div class="d-flex gap-2 align-items-end">
      <div class="flex-grow-1">
        <label for="typeahead-prevent-manual-entry" translate>SEARCH</label>
        <input
          #productElement
          id="typeahead-prevent-manual-entry"
          type="text"
          class="form-control"
          [(ngModel)]="product"
          [ngbTypeahead]="search"
          [inputFormatter]="formatter"
          [resultFormatter]="formatter"
          (selectItem)="selectProduct($event)"
          (focus)="clearFields()"
          (ngModelChange)="$event ? productInputComp?.focusInput() : undefined"
          [editable]="false"
        />
      </div>

      <div class="quickorder-quantity">
        <label for="quantityElement" translate>QUANTITY</label>
        <lib-product-quantity-input
          [productId]="product?.id"
          [product]="product"
          [disabled]="disableQty"
          [selectOnFocus]="true"
          [(ngModel)]="quantity"
          (keyTyped)="onQuantityInputKeyPressed($event, productElement)"
        ></lib-product-quantity-input>
        <div *ngIf="disableQty && product" class="alert alert-warning mt-2 mb-0 py-2" role="alert">
          {{ 'NO_AVAILABILITY' | translate }}
        </div>
      </div>

      <div class="d-flex align-items-end d-lg-none">
        <button type="button" class="btn btn-primary quickorder-add-button" [disabled]="!product || disableQty" (click)="addProductToCart(quantity)">
          <i class="fas fa-cart-plus"></i>
          <span class="d-sm-none ms-1">{{ 'ADD_TO_CART' | translate }}</span>
        </button>
      </div>
    </div>

    <lib-quickorder-listing-product
      [product]="product"
      [assortment]="assortment"
      (valueChanged)="addProductToCart($event)"
    ></lib-quickorder-listing-product>
  </div>
  <div class="col-12 col-md-4 quickorder-summarize-col" tabindex="0" #quickorderSummarize>
    <lib-quickorder-summarize
      [cart]="cart"
      [cachedData]="cachedData"
      (selectProduct)="selectProductById($event); productInputComp?.focusInput()"
    ></lib-quickorder-summarize>
  </div>

  <div class="col-12 text-right fixed-bottom pr-5" [class.d-none]="isQuickorderSummarizeScrolledIntoView">
    <button type="button" class="btn btn-secondary" (click)="quickorderSummarize.focus()">
      <i class="fas fa-shopping-basket"></i>
    </button>
  </div>
</div>
